import { Home, Building2, BedDouble, UtensilsCrossed } from 'lucide-react';

/* Showroom candidate rooms supplied by the client (NYC exteriors). Images live in /public/showroom.
   quad = full window opening [tl, tr, br, bl] in % of the image; drop = presentation drop (0..1) for the
   contact sheet — selected rooms are retouched so the glass is never blocked (drop 1), 0.03 = open. */
const P = 1264 / 848; // portrait h/w
const L = 848 / 1264; // landscape h/w

export const SHOWROOM_CANDIDATES = [
  /* Nov 2026: living + office are portrait re-compositions of the client's reference photos (windows fully clear) */
  { id: 'living_day', selected: true, name: 'Living Room · Day', icon: Home, aspect: P, images: { day: '/showroom/living_day.jpeg' },
    shades: [
      { label: 'Left Window', quad: [[19.94, 21.01], [43.65, 21.04], [43.5, 57.99], [19.93, 57.99]], drop: 1 },
      { label: 'Right Window', quad: [[56.27, 21.04], [79.93, 21.04], [79.99, 57.99], [56.45, 57.99]], drop: 1 },
    ] },
  { id: 'living_night', selected: true, name: 'Living Room · Night', icon: Home, aspect: P, images: { day: '/showroom/living_night.jpeg' },
    shades: [
      { label: 'Left Window', quad: [[19.94, 21.01], [43.65, 21.04], [43.5, 57.99], [19.93, 57.99]], drop: 1 },
      { label: 'Right Window', quad: [[56.27, 21.04], [79.93, 21.04], [79.99, 57.99], [56.45, 57.99]], drop: 1 },
    ] },
  { id: 'office_day', selected: true, name: 'Home Office · Day', icon: Building2, aspect: P, images: { day: '/showroom/office_day.jpeg' },
    shades: [
      { label: 'Pane 1', quad: [[3.54, 17.87], [26.83, 17.87], [26.83, 75.14], [3.54, 75.14]], drop: 1 },
      { label: 'Pane 2', quad: [[26.83, 17.87], [50.45, 17.87], [50.45, 75.14], [26.83, 75.14]], drop: 1 },
      { label: 'Pane 3', quad: [[50.45, 17.87], [74.15, 17.87], [74.15, 75.14], [50.45, 75.14]], drop: 1 },
      { label: 'Pane 4', quad: [[74.15, 17.87], [97.49, 17.87], [97.49, 75.14], [74.15, 75.14]], drop: 1 },
    ] },
  { id: 'office_night', name: 'Home Office · Night', icon: Building2, aspect: P, images: { day: '/showroom/office_night.jpeg' },
    shades: [
      { label: 'Main Window', quad: [[9.8, 24.6], [60.2, 24.6], [60.2, 72.6], [9.8, 72.6]], drop: 0.6 },
      { label: 'Side Window', quad: [[64.0, 24.6], [79.4, 24.6], [79.4, 72.6], [64.0, 72.6]], drop: 1 },
    ] },
  { id: 'dining_day', selected: true, name: 'Dining Room · Day', icon: UtensilsCrossed, aspect: P, images: { day: '/showroom/dining_day.jpeg' },
    shades: [
      { label: 'Left Window', quad: [[3.53, 19.45], [33.72, 25.69], [33.74, 63.9], [3.81, 68.54]], drop: 1 },
      { label: 'Right Window', quad: [[40.09, 27.46], [56.37, 30.96], [56.37, 60.24], [39.91, 62.78]], drop: 1 },
    ] },
  { id: 'bedroom_night', selected: true, name: 'Bedroom · Night', icon: BedDouble, aspect: P, images: { day: '/showroom/bedroom_night.jpeg' },
    shades: [
      { label: 'Left Pane', quad: [[27.19, 18.91], [51.85, 18.91], [51.86, 60.91], [26.9, 60.91]], drop: 1 },
      { label: 'Right Pane', quad: [[51.77, 18.93], [77.13, 18.78], [77.14, 60.91], [51.93, 60.91]], drop: 1 },
    ] },
  { id: 'bedroom_day', selected: true, name: 'Bedroom · Day', icon: BedDouble, aspect: P, images: { day: '/showroom/bedroom_day.jpeg' },
    shades: [
      { label: 'Left Pane', quad: [[27.19, 18.91], [51.85, 18.91], [51.86, 60.91], [26.9, 60.91]], drop: 1 },
      { label: 'Right Pane', quad: [[51.77, 18.93], [77.13, 18.78], [77.14, 60.91], [51.93, 60.91]], drop: 1 },
    ] },
  { id: 'dining_night', name: 'Dining Room · Night', icon: UtensilsCrossed, aspect: P, images: { day: '/showroom/dining_night.jpeg' },
    shades: [
      { label: 'Left Window', quad: [[15.7, 23.7], [44.6, 23.7], [44.6, 62.3], [15.7, 62.3]], drop: 0.6 },
      { label: 'Right Window', quad: [[55.4, 23.7], [84.3, 23.7], [84.3, 62.3], [55.4, 62.3]], drop: 0.03 },
    ] },
  { id: 'penthouse_day', name: 'Penthouse · Day', icon: Home, aspect: L, images: { day: '/showroom/penthouse_day.jpeg' },
    shades: [
      { label: 'Pane 1', quad: [[11.3, 19.2], [23.6, 19.2], [23.6, 69.9], [11.3, 69.9]], drop: 0.6 },
      { label: 'Pane 2', quad: [[24.7, 19.2], [36.9, 19.2], [36.9, 69.9], [24.7, 69.9]], drop: 0.6 },
      { label: 'Pane 3', quad: [[37.9, 19.2], [50.0, 19.2], [50.0, 69.9], [37.9, 69.9]], drop: 0.6 },
      { label: 'Pane 4', quad: [[51.0, 19.2], [63.1, 19.2], [63.1, 69.9], [51.0, 69.9]], drop: 1 },
      { label: 'Pane 5', quad: [[64.5, 19.2], [75.9, 19.2], [75.9, 69.9], [64.5, 69.9]], drop: 1 },
      { label: 'Pane 6', quad: [[77.1, 19.2], [89.4, 19.2], [89.4, 69.9], [77.1, 69.9]], drop: 0.6 },
    ] },
  { id: 'living_trees', name: 'Living Room · Garden', icon: Home, aspect: L, images: { day: '/showroom/living_trees.jpeg' },
    shades: [
      { label: 'Left Panel', quad: [[15.2, 16.6], [37.5, 16.9], [37.5, 73.2], [15.2, 74.2]], drop: 0.6 },
      { label: 'Center Panel', quad: [[39.5, 16.8], [60.7, 16.8], [60.7, 73.1], [39.5, 73.2]], drop: 1 },
      { label: 'Right Panel', quad: [[62.7, 16.8], [83.7, 16.7], [83.7, 72.9], [62.7, 73.0]], drop: 0.6 },
    ] },
];
